import React, { useState } from "react";
import { Menu, X, Info } from "lucide-react";
import { BIZ, SLUG, NAV_PAGES } from "./trenasData";
import ConceptCTAPill from "@/components/ConceptCTAPill";

export const NAVY = "#0B1F45";
export const GOLD = "#C9A24A";
export const CREAM = "#F7F4EC";
export const INK = "#1B2130";
export const SLATE = "#565A66";

// Shared chrome for the 5-page Treñas Law concept site. A plain JSX wrapper (not wired into
// React Router) — each page imports and renders <TrenasLayout active="...">, matching the flat
// top-level-route convention used everywhere else in this codebase (no nested <Route> blocks).
export default function TrenasLayout({ active, children }) {
  const [open, setOpen] = useState(false);
  const basePath = `/${SLUG}`;

  return (
    <div className="min-h-screen" style={{ background: CREAM, color: INK, fontFamily: "'Inter', sans-serif" }} data-testid="trenas-concept-root">
      <style>{`@import url('https://fonts.googleapis.com/css2?family=EB+Garamond:wght@500;600;700&family=Inter:wght@400;500;600;700&display=swap'); .trenas-serif{font-family:'EB Garamond',serif;}`}</style>

      <div data-testid="law-disclaimer" className="bg-black text-white text-center text-xs py-2.5 px-4">
        <span className="inline-flex items-center gap-2"><Info size={13} style={{ color: GOLD }} />Concept website created by <a href="https://mysitecare.eu/ph" target="_blank" rel="noopener noreferrer" className="underline decoration-white/40 hover:decoration-white">MySiteCare</a> — not currently operated by or affiliated with {BIZ.name}.</span>
      </div>

      <header className="sticky top-0 z-40 shadow-sm" style={{ background: NAVY }}>
        <nav className="max-w-6xl mx-auto px-5 sm:px-8 h-20 flex items-center justify-between">
          <a href={basePath} data-testid="trenas-logo" className="flex items-center gap-3">
            <span className="hidden sm:flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-white overflow-hidden">
              <img src="/law/trenas-law-iloilo-concept/crest.jpg" alt="" className="h-9 w-9 object-contain" />
            </span>
            <span className="trenas-serif text-lg sm:text-xl text-white leading-tight">
              Treñas Rubias Dela Cruz<br className="hidden sm:block" /> Lee-Trimañez &amp; Associates
            </span>
          </a>
          <div className="hidden lg:flex items-center gap-7 shrink-0 ml-6">
            {NAV_PAGES.map((p) => (
              <a
                key={p.key}
                href={`${basePath}${p.path}`}
                data-testid={`trenas-nav-${p.key}`}
                className="text-sm font-medium transition-colors"
                style={{ color: active === p.key ? GOLD : "rgba(255,255,255,0.75)" }}
              >
                {p.label}
              </a>
            ))}
          </div>
          <button className="lg:hidden text-white ml-4" onClick={() => setOpen(!open)} data-testid="trenas-menu-toggle" aria-label="Menu">{open ? <X size={22} /> : <Menu size={22} />}</button>
        </nav>
        {open && (
          <div className="lg:hidden px-5 pb-4 space-y-1" style={{ background: NAVY }}>
            {NAV_PAGES.map((p) => (
              <a key={p.key} href={`${basePath}${p.path}`} onClick={() => setOpen(false)} className="block py-2.5 font-medium" style={{ color: active === p.key ? GOLD : "rgba(255,255,255,0.85)" }}>{p.label}</a>
            ))}
          </div>
        )}
      </header>

      {children}

      <footer className="py-8" style={{ background: NAVY }}>
        <div className="max-w-6xl mx-auto px-5 sm:px-8 flex flex-col sm:flex-row justify-between gap-3 text-xs text-white/50">
          <p className="trenas-serif text-base" style={{ color: GOLD }}>{BIZ.shortName}</p>
          <p>This is an unsolicited concept website by MySiteCare. Not operated by or affiliated with {BIZ.name}. Confirm current details before visiting.</p>
        </div>
      </footer>

      <ConceptCTAPill slug={SLUG} />
    </div>
  );
}
